import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../config/index";
import {connect, setStore} from "trim-redux";
import { withSnackbar } from 'notistack';
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar/Avatar";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import withWidth from "@material-ui/core/withWidth/withWidth";
import Button from "@material-ui/core/Button/Button";
import Grid from "@material-ui/core/Grid/Grid";
import Role from "../../components/elements/Role";
import {truncate} from "../../../config/values";
import Container from "@material-ui/core/Container/Container";
import FilesDirectoryManager from "./Components/FilesDirectoryManager";
import MoveToDirectoryDialog from "./Components/MoveToDirectoryDialog";
import AppCardLoaderFields from "../../components/Skeletons/AppCardLoaderFields";
import FilesDirectoryManagerGrid from "./Components/FilesDirectoryManagerGrid";
import {FieldSkeleton} from "../../components/Skeletons/FieldSkeleton";
import {ListSkeleton} from "../../components/Skeletons/ListSkeleton";
import {GridSkeleton} from "../../components/Skeletons/GridSkeleton";
import OndemandVideoRoundedIcon from "@material-ui/icons/OndemandVideoRounded";
import AudiotrackIcon from "@material-ui/icons/Audiotrack";
import DescriptionRoundedIcon from "@material-ui/icons/DescriptionRounded";
import {Pagination} from "@material-ui/lab";
import AddFile from "./Components/AddFile";
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import {FolderRounded, ListAltRounded} from "@material-ui/icons";
import LinkIcon from "@material-ui/icons/Link";
import ImgPreviewModal from "./Components/ImgVPreviewDialog";
import clsx from "clsx";
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import TextField from "@material-ui/core/TextField/TextField";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import Typography from "@material-ui/core/Typography/Typography";
import Hidden from "@material-ui/core/Hidden/Hidden";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import Accordion from "@material-ui/core/Accordion/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary/AccordionSummary";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import SubTitle from "../../components/elements/SubTitle";
import FilterListRoundedIcon from "@material-ui/icons/FilterListRounded";
import AccordionDetails from "@material-ui/core/AccordionDetails/AccordionDetails";
import {DEMO} from "../../../config/Security";
class FileManager extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    state = {
        owner: 'self',
        type:  this.props.fileType !== undefined ? this.props.fileType : 'image',
        fileType : this.props.fileType !== undefined ? this.props.fileType : 'image',
        files: [],
        LinkDialog:false,
        links:null,
        open_filter:false,
        current_directory:null,
        loading:true,
        search:'',
        current_page:1,
        total_pages:0,
        selected_files:[],
        selected_ids:[],
    };
    componentDidMount(){
        this.loadData();
    }
    OpenDialog(data){
        let links = []
        links[0] = `${defaultVariabls.uploads}/FileManager/${data.name}_small.${data.extension}`;
        links[1] = `${defaultVariabls.uploads}/FileManager/${data.name}_medium.${data.extension}`;
        links[2] = `${defaultVariabls.uploads}/FileManager/${data.name}.${data.extension}`;
        this.setState({
            links,
            LinkDialog:true
        })
    }
    handleCloseDialog(){
        this.setState({
            LinkDialog:false
        })
    }
    handleClickLink(link){
        navigator.clipboard.writeText(link);
        this.setState({
            LinkDialog:false
        })
        this.props.enqueueSnackbar(Translate.linkCopied, {
            variant: 'info',
        });
    }
    addImage(data){
        const {handleSetImage} = this.props;
        if(handleSetImage !== undefined){
            handleSetImage(data)
        }
    }

    Changed(){
        this.loadData();
    }

    async loadData(){
        let {current_page,search,current_directory,type,owner} = this.state;
        let loginToken = localStorage.getItem('ACT');
        const data = new FormData();
        data.append('type', type);
        data.append('owner', owner);
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.post(`${defaultVariabls.url}/file/getAll?page=${current_page}&per_page=${12}&search=${search}${current_directory !== null ? '&directory='+current_directory : ''}&width=${!!this.props.defined_width ? this.props.defined_width : ''}&height=${!!this.props.defined_height ? this.props.defined_height : ''}`, data,config)
                .then(async response => {
                    let files = [];
                    await response.data.data.map((row) =>(
                        files.push({
                            thumbnail: `${defaultVariabls.uploads}/FileManager/${row.name}_small.${row.extension}`,
                            source: `${defaultVariabls.uploads}/FileManager/${row.name}.${row.extension}`,
                            ImageName: truncate(row.name,20),
                            name: row.name,
                            extension: row.extension,
                            alt: row.alt,
                            type: row.type,
                            owner: row.owner.first_name+" "+row.owner.last_name,
                            id: row.id,
                            created_at:row.updated_at
                        })
                    ));
                    this.setState({
                        files,
                        loading:false,
                        total_pages : parseInt(response.data.last_page),
                    })
                }).catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }

    async onDeleteFile(id,hasNotif = true) {
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/file/remove`, data, config)
            .then(response => {
                if(response.data.hasError){
                    this.props.enqueueSnackbar(response.data.message, {
                        variant: 'error',
                    });
                }else{
                    if(hasNotif){
                        this.props.enqueueSnackbar(Translate.deleteFile, {
                            variant: 'success',
                        });
                    }
                }
                this.loadData();

                return true
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.deleteFileFailed, {
                    variant: 'error',
                });
                return false
            });
    }
    async onDeleteSelectedFiles(){
        let {selected_files} = this.state;
        await selected_files.map((row) =>(
            this.onDeleteFile(row.id,false)

        ));
        await this.loadData();
        await this.props.enqueueSnackbar(Translate.deleteSelectedFiles, {
            variant: 'success',
        });

    }
    async moveFiles(){
        await this.setState({
            moveItems:this.state.selected_files,
            open_move_dialog:true,
        })
    }
    onEditFile(file) {
        let data = new FormData();
        data.append('id', file.id);
        data.append('alt', file.alt);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/file/edit`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.editFile, {
                    variant: 'success',
                });
                return true
            })
            .catch(error => {
                this.props.enqueueSnackbar(Translate.editFileFailed, {
                    variant: 'error',
                });
                return false
            });
    }
    handleChangeLoader(){
        this.setState({
            ChangeLoader:!this.state.ChangeLoader
        })
    }
    async handleChangeOwner(e) {
        this.setState({
            ChangeLoader:true
        })
        let target = e.target;
        let owner = target.value;
        await this.setState({
            owner
        });
        this.loadData();
    }
    async handleChangeType(e) {
        this.setState({
            ChangeLoader:true
        })
        let target = e.target;
        let type = target.value;
        await this.setState({
            type
        });
        this.loadData();
    }
    addItems(){
        let {selected_files} = this.state;
        selected_files.map((row) =>(
            this.addImage(row)
        ));
    }
    async handleCurrentDirectory(current_directory){
        await this.setState({
            current_directory
        })
        await this.loadData();
    }
    reloadMove(){
        this.setState({
            open_move_dialog:false,
            moveItems:null,
            loading:true,
            selected_files:[],
            selected_ids:[],
        })
        this.loadData();
    }
    async handleCurrentPage(current_page){
        await this.setState({
            current_page
        })
        await this.loadData();
    }
    handleSelectFile(file){
        let {page} = this.props;
        let {selected_files,selected_ids} = this.state;
        let {multiInsert} = this.props;
        if(multiInsert){
            let find = selected_ids.indexOf(file.id);
            if(find === -1){
                selected_ids.push(file.id);
                selected_files.push(file);
            }else{
                selected_ids.splice(find, 1);
                selected_files.splice(find, 1);
            }

        }else{
            if(selected_ids[0] === file.id){
                selected_ids = [];
                selected_files = [];
            }else{
                selected_ids[0] = file.id
                selected_files[0] = file
            }
        }
        this.setState({
            selected_files,
            selected_ids
        })

    }
    async handleChangeSearch(e) {
        this.setState({
            ChangeLoader:true
        })
        let target = e.target;
        let search = target.value;
        await this.setState({
            search
        });
        this.loadData();
    }
    render(){
        let {LinkDialog,selected_files,search,selected_ids,loading,files,links,fileType,type,owner,open_filter,current_directory} = this.state;
        let {user,page} = this.props;

        return (
            <Container maxWidth="xl" style={{minHeight:600,padding:0,overflow:'hidden'}}>
                    {
                        !!page &&
                        <Grid container spacing={2}>
                            <Role type="admin" role="admin">
                                <Grid item xs={12} style={{marginBottom:20}}>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreRoundedIcon />}
                                            aria-controls="panel2a-content"
                                            id="panel2a-header"
                                        >
                                            <SubTitle align="left" style={{marginBottom:0}}>
                                                <IconButton size="small">
                                                    <FilterListRoundedIcon/>
                                                </IconButton>
                                                {Translate.filters}
                                            </SubTitle>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container spacing={2} alignItems="center" direction="row">
                                                {
                                                    !DEMO &&
                                                    <Grid item xs={12} md={3}>
                                                        <TextField
                                                            select
                                                            variant="outlined"
                                                            fullWidth
                                                            label={Translate.chooseOwnerFile}
                                                            value={owner}
                                                            onChange={this.handleChangeOwner.bind(this)}
                                                        >
                                                            <MenuItem value='self'>{Translate.selfFiles}</MenuItem>
                                                            <MenuItem value='admins'>{Translate.adminsFiles}</MenuItem>
                                                            <MenuItem value='all'>{Translate.everyBodyFiles}</MenuItem>
                                                        </TextField>
                                                    </Grid>
                                                }
                                                <Grid item xs={12} md={3}>
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        variant="outlined"
                                                        value={type}
                                                        label={Translate.chooseFormat}
                                                        onChange={this.handleChangeType.bind(this)}
                                                    >
                                                        {
                                                            fileType === 'image' || fileType === 'all' || fileType === 'document' ? <MenuItem value='image' >{Translate.image}</MenuItem> :null
                                                        }
                                                        {
                                                            fileType === 'video' || fileType === 'all'  ? <MenuItem value='video'>{Translate.video}</MenuItem> :null
                                                        }
                                                        {
                                                            fileType === 'document' || fileType === 'all'  ? <MenuItem value='document'>{Translate.document}</MenuItem> :null
                                                        }
                                                        {
                                                            fileType === 'audio' || fileType === 'all'  ? <MenuItem value='audio'>{Translate.audio}</MenuItem> :null
                                                        }
                                                        {
                                                            fileType === 'all'  ? <MenuItem value='all'>{Translate.allTypes}</MenuItem> :null
                                                        }
                                                    </TextField>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            </Role>
                        </Grid>
                    }
                <Grid container spacing={2} style={!!page ? {background:"#fff"} : null}>
                    <Grid item xs={12} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:'13px 30px 5px',boxShadow:!!page ? "rgba(0,0,0,.08) 0 3px 4px" : "0 0 5px rgba(0,0,0,.3)"}}>
                        <div style={{display:'flex',alignItems:'center'}}>
                            <AddFile
                                ChangeLoader={this.handleChangeLoader.bind(this)}
                                Changed={this.Changed.bind(this)}
                                defined_width={this.props.defined_width}
                                defined_height={this.props.defined_height}
                                current_directory={current_directory}
                            />
                            {
                                !page &&
                                <Hidden mdDown>
                                    <Button
                                        color="secondary"
                                        variant="contained"
                                        style={{marginLeft:10}}
                                        disabled={selected_ids.length === 0}
                                        onClick={() => this.addItems()}
                                    >
                                        {Translate.chooseMedia}
                                    </Button>
                                </Hidden>
                            }

                            <IconButton
                                color="secondary"
                                variant="contained"
                                disabled={selected_ids.length === 0}
                                onClick={() => this.onDeleteSelectedFiles()}
                            >
                                <DeleteRoundedIcon/>
                            </IconButton>
                            <Role type="admin" role="admin">
                            <Hidden mdDown>
                                <IconButton
                                    color="secondary"
                                    variant="contained"
                                    disabled={selected_ids.length === 0}
                                    onClick={() => this.moveFiles()}
                                >
                                    <FolderRounded/>
                                </IconButton>
                            </Hidden>
                            </Role>
                        </div>
                        <TextField
                            size="small"
                            variant="outlined"
                            value={search}
                            label={Translate.search}
                            onChange={this.handleChangeSearch.bind(this)}
                            InputProps={{
                                endAdornment: (
                                    <SearchRoundedIcon />
                                ),
                            }}
                        />
                    </Grid>
                    <Hidden mdDown>
                        <Role type="admin" role="admin">
                        <Grid item xs={12} md={3} style={{padding:0,paddingRight:8}}>
                                <FilesDirectoryManagerGrid
                                    handleCurrentDirectory={this.handleCurrentDirectory.bind(this)}
                                />
                        </Grid>
                        </Role>
                    </Hidden>

                    <Grid item xs={12} md={user.role.type === "admin" ? 9 : 12}>
                        {
                            !loading ?
                                <Grid container spacing={2} style={{height:"67vh",overflow:'auto',padding:'10px 10px 10px 20px',marginBottom:30}}>
                                    {
                                        files.map((file,index) => (
                                            <Grid item xs={6} md={4} lg={user.role.type === "admin" ? 4 : 3} key={index}>
                                                <Button
                                                    variant="outlined"
                                                    color={selected_ids.indexOf(file.id) > -1 ? "primary" : 'secondary'}
                                                    className={selected_ids.indexOf(file.id) > -1 ? clsx(this.classes.fileMangerGridItem,'active') : this.classes.fileMangerGridItem}
                                                    onClick={() => this.handleSelectFile(file)}
                                                >
                                                    <span className={"name"}>
                                                        <span>
                                                            {file.name}.{file.extension}
                                                        </span>
                                                        <span>
                                                            {Translate.code}: <strong>{file.id}</strong>
                                                        </span>
                                                    </span>
                                                    {
                                                        file.type === 'image' ?
                                                            <>
                                                                <img src={file.thumbnail} alt={file.name}/>
                                                            </>
                                                            : file.type === 'video' ?
                                                                <OndemandVideoRoundedIcon style={{fontSize: 60,color: "#6d6d6d"}}/> :
                                                                file.type === 'audio' ?
                                                                    <AudiotrackIcon style={{fontSize: 60,color: "#6d6d6d"}}/> :
                                                                    <DescriptionRoundedIcon style={{fontSize: 60,color: "#6d6d6d"}}/>

                                                    }
                                                    <div className="action-holder">
                                                        <IconButton size="small" style={{color:"#fff"}} color="primary" onClick={() => this.OpenDialog(file)}><LinkIcon /></IconButton>
                                                        {
                                                            file.type === "image" &&
                                                            <ImgPreviewModal style={{color:"#fff",margin:"0 5px"}} source={file.source}/>

                                                        }
                                                    </div>
                                                    <div className='active-item'>
                                                        <CheckCircleRoundedIcon/>
                                                    </div>
                                                </Button>
                                            </Grid>
                                        ))
                                    }
                                    {
                                        this.state.total_pages > 1 &&
                                        <Grid item xs={12}>
                                            <Pagination count={this.state.total_pages} page={this.state.current_page} onChange={(e,val) => this.handleCurrentPage(val)} />
                                        </Grid>
                                    }
                                    {
                                        files.length === 0 &&
                                        <Grid item xs={12} style={{textAlign:"center",marginTop:100}}>
                                            <ListAltRounded/>
                                            <Typography>{Translate.noMediaFound}</Typography>
                                        </Grid>
                                    }
                                </Grid>
                                :
                                <GridSkeleton
                                    gridy={user.role.type !== "admin"}
                                    className={'grid-skeleton'}/>
                        }


                    </Grid>
                    {
                        !page &&
                        <div className="file-manager-footer">
                            <Button
                                color="secondary"
                                variant="contained"
                                disabled={selected_ids.length === 0}
                                onClick={() => this.addItems()}
                            >
                                {Translate.chooseMedia}
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => this.props.closeFileManager()}
                                style={{marginRight:10,marginLeft:10}}

                            >
                                {Translate.cancle}
                            </Button>

                        </div>
                    }

                </Grid>
                <Dialog onClose={this.handleCloseDialog.bind(this)}  open={LinkDialog}>
                    <DialogTitle>{Translate.ChooseImageLink}</DialogTitle>
                    {
                        LinkDialog ?
                            <List>
                                <ListItem button onClick={() => {this.handleClickLink(links[0])}}>
                                    <ListItemText style={{textAlign:"left"}} primary={links[0]} />
                                    <ListItemAvatar style={{direction:"ltr"}}>
                                        <Avatar src={links[0]} className={this.classes.small}/>
                                    </ListItemAvatar>
                                </ListItem>
                                <ListItem button onClick={() => {this.handleClickLink(links[1])}}>
                                    <ListItemText style={{textAlign:"left"}}  primary={links[1]} />
                                    <ListItemAvatar style={{direction:"ltr"}}>
                                        <Avatar src={links[1]}/>
                                    </ListItemAvatar>
                                </ListItem>
                                <ListItem  button onClick={() => {this.handleClickLink(links[2])}}>
                                    <ListItemText style={{textAlign:"left"}} primary={links[2]} />
                                    <ListItemAvatar style={{direction:"ltr"}}>
                                        <Avatar src={links[2]} className={this.classes.large}/>
                                    </ListItemAvatar>
                                </ListItem>
                            </List>
                            : null
                    }
                </Dialog>
                {
                    !!this.state.open_move_dialog &&
                    <MoveToDirectoryDialog
                        items={this.state.moveItems}
                        reload={() => this.reloadMove()}
                        hanleClose={() => this.setState({
                            open_move_dialog:false,
                            moveItems:null,

                        })}
                    />
                }
            </Container>

        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withWidth()(withSnackbar(withStyles(Styles)(connect(mstp)(FileManager))));
